import React from 'react'
import { AreaDot, PowerPrice } from '../../../../dynamic-power-prices/types'
import { isSameMinute } from '@e3dc-react/shell/Libs/date'

interface Props {
  data: AreaDot
  color: string
  currentPowerPriceValues: PowerPrice
}

/**
 *  This component creates a customized dot on the point with the current time
 * @param data is any type because rechart does not export the actual type for this internally provided data
 * @param timeIndex
 * @param color
 */
const CustomizedDot: React.VFC<Props> = ({ data, color, currentPowerPriceValues }) => {
  const { cx, cy } = data

  const showDot = data?.payload?.from && isSameMinute(new Date(currentPowerPriceValues.validFrom), new Date(data.payload.from))

  if (showDot) {
    return (
      <svg x={cx ? cx - 6 : 0} y={cy ? cy - 6 : 0} width="12" height="12" viewBox="0 0 8 9" fill="none">
        <rect width="8" height="8" rx="4" transform="matrix(-1 0 0 1 7.99414 0.157898)" fill={color} />
        <rect width="6" height="6" rx="3" transform="matrix(-1 0 0 1 7 1)" fill="white" />
      </svg>
    )
  }
  return <></>
}

export default CustomizedDot
